const unformatNumber = (number = "0") => {
  if (number) {
    return number.toString().includes(",") ? number.replace(/,/g, "") : number;
  } else {
    return 0;
  }
};

const formatNumber = (_number, decimalPlaces) => {
  let _formattedNumber = "";
  let _decimalPlaces = "";

  if (_number !== null && _number !== undefined) {
    if (_number?.toString() === "0") {
      return "0";
    }

    let number = _number?.toString()?.includes(",")
      ? _number?.toString().replaceAll(",", "")
      : _number?.toString();

    let last = number.charAt(number.length - 1);
    if (_number !== "") {
      if (last === ".") {
        if (number.substr(0, number.length - 1).includes(".")) {
          _formattedNumber = number.substr(0, number.length - 1);
        } else {
          _formattedNumber = _number;
        }
      } else {
        if (number.includes(".")) {
          _decimalPlaces = number.substr(number.indexOf("."));
        }
        let cleaned = number.replace(/,/g, "");
        if (cleaned?.includes(".")) cleaned = cleaned?.split(".")[0];

        _formattedNumber = new Intl.NumberFormat().format(cleaned);
      }
    }
  }

  return (_formattedNumber += _decimalPlaces?.slice(
    0,
    decimalPlaces ? decimalPlaces + 1 : _decimalPlaces?.length
  ));
};

const numberRegex = /^[0-9,.]*$/;

export { formatNumber, unformatNumber, numberRegex };
